<script setup>
import {useBaseStore} from "~/stores/base";

const emits = defineEmits(["back", "close"])

/** props **/
const props = defineProps({
  open: {
    default: false,
    required: true
  },
  title: {
    default: ""
  },
  borderRadius: {
    default: "0 0 0 0"
  },
  btnBackVisible: {
    default: false,
  },
  btnCloseVisible: {
    default: false,
  },
  zIndex: {
    default: 2,
  },
  top: {
    default: 'calc(58px + 20px)'
  },
  appendToBody: {
    default: false
  }
})

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)

/** watch **/
watch(() => props.open, (open) => {
  if (open) {
    document.body.style = "overflow: hidden";
  } else {
    document.body.style = "overflow: auto";
  }
})

/** methods **/

/** lifecycle **/
onMounted(() => {

})
</script>

<template>
  <teleport to="body" v-if="appendToBody">
    <transition name="fade" mode="out-in">
      <div class="_modal-mobile" v-if="props.open && isMobile" @click="emits('close')" :style="{zIndex}">
        <div class="_content" @click.stop :style="{borderRadius, marginTop: top ? top : 'calc(58px + 20px)'}">
          <img v-if="btnCloseVisible" class="_close" src="@/assets/img/icon-close-black.svg" alt="close"
               @click="emits('close')">
          <slot></slot>
        </div>
      </div>
    </transition>
  </teleport>
  <transition name="fade" mode="out-in" v-else>
    <div class="_modal-mobile" v-if="props.open && isMobile" @click="emits('close')" :style="{zIndex}">
      <div class="_content" @click.stop :style="{borderRadius, marginTop: top ? top : 'calc(58px + 20px)'}">
        <img v-if="btnCloseVisible" class="_close" src="@/assets/img/icon-close-black.svg" alt="close"
             @click="emits('close')">
        <slot></slot>
      </div>
    </div>
  </transition>
  <teleport to="body" v-if="appendToBody">
    <transition name="fade" mode="out-in">
      <div class="_modal-desktop" v-if="props.open && !isMobile" @click="emits('close')" :style="{zIndex}">
        <div class="_content" @click.stop :style="{borderRadius}">
          <div class="_header" v-if="title">
            <div class="_header_left">
              <div class="_back" @click="emits('back')" v-if="btnBackVisible">
                <img src="@/assets/img/icon-arrow-left.svg" alt="arrow">
              </div>
            </div>
            <div class="_title">
              {{ title }}
            </div>
            <div class="_header_right">
              <div class="_close" @click="emits('close')" v-if="btnCloseVisible">
                <img src="@/assets/img/icon-close-black.svg" alt="close">
              </div>
            </div>
          </div>
          <img v-if="btnCloseVisible && !title" class="_close_small" src="@/assets/img/icon-close-black.svg" alt="close" @click="emits('close')">
          <slot></slot>
        </div>
      </div>
    </transition>
  </teleport>
  <transition name="fade" mode="out-in" v-else>
    <div class="_modal-desktop" v-if="props.open && !isMobile" @click="emits('close')" :style="{zIndex}">
      <div class="_content" @click.stop :style="{borderRadius}">
        <div class="_header" v-if="title">
          <div class="_header_left">
            <div class="_back" @click="emits('back')" v-if="btnBackVisible">
              <img src="@/assets/img/icon-arrow-left.svg" alt="arrow">
            </div>
          </div>
          <div class="_title">
            {{ title }}
          </div>
          <div class="_header_right">
            <div class="_close" @click="emits('close')" v-if="btnCloseVisible">
              <img src="@/assets/img/icon-close-black.svg" alt="close">
            </div>
          </div>
        </div>
        <img v-if="btnCloseVisible && !title" class="_close_small" src="@/assets/img/icon-close-black.svg" alt="close" @click="emits('close')">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
@import "src/assets/config";

._modal-mobile {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: flex-start;

  ._content {
    //margin-top: calc($mobile-header-height + 20px);
    background-color: white;
    min-width: 300px; // download modal
    min-height: 200px;
    /* Shadow/lg */
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.20);
    position: relative;
    overflow: auto;

    ._close {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
  }
}

._modal-desktop {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;

  ._content {
    background-color: white;
    min-width: 375px;
    min-height: 200px;
    /* Shadow/lg */
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.20);
    position: relative;
    overflow: auto;
    //padding: 16px;

    ._header {
      width: 100%;
      height: 72px;
      margin-top: 16px;
      padding: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      ._header_left {
        width: 40px;
        height: 40px;

        ._back {
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      ._title {
        color: $color-gray-800;
        font-family: "Alternate Gothic No3 D";
        font-size: 36px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px; /* 88.889% */
        letter-spacing: -0.36px;
        text-transform: uppercase;
        padding-top: 12px;
      }

      ._header_right {
        width: 40px;
        height: 40px;

        ._close {
          width: 40px;
          height: 40px;
          border: 1px $color-BNTO-beige-dark solid;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    ._close_small {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }

  }
}
</style>
